import './css/App.css';

import TopNavbar from "./components/TopNavbar";
import MapPage from "./pages/MapPage";
import AboutPage from "./pages/AboutPage";
import ManagePoints from "./pages/ManagePoints";
import EditPoint from "./pages/EditPoint";
import ViewPoint from "./pages/ViewPoint";
import CreatePoint from "./pages/CreatePoint";
import Callback from "./pages/Callback"; // add this import near other page imports
import ImportPoints from "./pages/ImportPoints";

import ProtectedRoute from "./components/ProtectedRoute";

import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

function MainLayout({ }) {
    // simple layout that shows top navbar and renders the matched child route
    return (
        <div className="App">
            <TopNavbar />
            <Outlet />
        </div>
    );
}

function App() {
    const domain = process.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
    const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

    // If Auth0 is not configured, render without provider (dev fallback).
    const appContent = (
        <BrowserRouter>
            <Routes>
                {/* renders MapPage with no header/footer */}
                <Route path="/assetmap" element={<MapPage />} />

                {/* callback route for Auth0 */}
                <Route path="/callback" element={<Callback />} />

                {/* All other routes render within MainLayout (navbar + outlet) */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Navigate to="/map" replace />} />
                    <Route path="/map" element={<MapPage />} />
                    <Route path="/about" element={<AboutPage />} />

                    {/* Protected manage routes */}
                    <Route path="/manage" element={<ProtectedRoute><ManagePoints /></ProtectedRoute>} />
                    <Route path="/manage/create" element={<ProtectedRoute><CreatePoint /></ProtectedRoute>} />
                    <Route path="/manage/edit/:id" element={<ProtectedRoute><EditPoint /></ProtectedRoute>} />
                    <Route path="/manage/import" element={<ProtectedRoute><ImportPoints /></ProtectedRoute>} />

                    <Route path="/manage/view/:id" element={<ViewPoint />} />
                    <Route path="*" element={<Navigate to="/map" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );

    if (!domain || !clientId) {
        // Auth0 not configured: return app without auth provider
        return appContent;
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{
                redirect_uri: `${window.location.origin}/callback`,
                audience: audience || undefined
            }}
            // Persist session across reloads
            cacheLocation="localstorage"
            // Use refresh tokens so the SDK can renew access tokens when needed.
            useRefreshTokens={true}
        >
            {appContent}
        </Auth0Provider>
    );
}

export default App;
